import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da1vrnrk8r5te5mqsck0";

export default function SubscribeSection() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = (data.get("website_alt") as string) || "";
    if (honeypot.trim()) {
      setStatus("success");
      setMessage("订阅成功，新番上架第一时间通知你！");
      form.reset();
      return;
    }
    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key !== "website_alt" && value) payload.append(key, value as string);
    });
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = (parsed?.meta as Record<string, unknown>) || null;
      const code = parsed?.code;
      const serverMsg = (meta?.message as string) || (parsed?.message as string) || (meta?.detail as string) || responseText;
      if (res.ok && code === "OK" && !/spam/i.test(serverMsg)) {
        setStatus("success");
        setMessage("订阅成功，新番上架第一时间通知你！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden py-16 md:py-24" aria-label="订阅新作资讯">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20anime%20background%20of%20colorful%20comic%20pages%20and%20speech%20bubbles%20floating%20in%20warm%20sunlight%2C%20vibrant%20coral%20orange%20and%20amber%20palette%20with%20teal%20accents%2C%20bright%20cheerful%20energetic%20illustration%20style%2C%20soft%20warm%20glow%20and%20clean%20composition&width=1600&height=700&seq=subscribe-dingdong-01&orientation=landscape"
          alt="订阅叮咚漫画网新作资讯"
          title="叮咚漫画网新番订阅"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 to-primary-900/70" />
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-semibold text-background-50 backdrop-blur">
          <i className="ri-mail-send-line text-secondary-300" /> 订阅提醒
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-4xl">
          订阅新番速递 · 永远快人一步
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-background-50/90 md:text-base">
          留下邮箱，第一时间获取叮咚漫画网新作首发、独家抢先看与新番上架速递提醒。
        </p>

        <form
          data-readdy-form="da1vrnrk8r5te5mqsck0"
          onSubmit={handleSubmit}
          className="mx-auto mt-7 flex max-w-xl flex-col gap-3 sm:flex-row"
        >
          <div className="flex flex-1 items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-5 backdrop-blur">
            <i className="ri-mail-line text-background-50/80" />
            <input
              type="email"
              name="email"
              required
              maxLength={200}
              placeholder="请输入你的邮箱地址"
              aria-label="邮箱地址"
              className="w-full bg-transparent py-3 text-sm text-background-50 outline-none placeholder:text-background-50/70"
            />
          </div>
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-secondary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
          >
            订阅新作提醒
          </button>
        </form>

        {status === "success" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-2 text-sm font-medium text-background-50" role="status">
            <i className="ri-checkbox-circle-fill" /> {message}
          </p>
        )}
        {status === "error" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-red-500/90 px-4 py-2 text-sm font-medium text-background-50" role="alert">
            <i className="ri-error-warning-fill" /> {message}
          </p>
        )}
      </div>
    </section>
  );
}